import GalleryPreferences from './gallery-preferences';
export default {
  props: ['coursework', 'coursework_entry'],
  template: '#link_uploader_template',
  data() {
    return {
      showLinkPreview: false
    };
  },
  components: {
    'gallery-preferences': GalleryPreferences
  },
  watch: {
    'coursework_entry.coursework_fields': {
      handler: _.debounce(function(fields) {
        this.showPreview(fields[0].coursework_field_entries[0].value);
      }, 300),
      deep: true
    }
  },
  methods: {
    showPreview(url) {
      if (this.errors.has('url'))
        return;

      let self = this;
      let request = new Kadenze.AjaxRequest({
        type: 'GET',
        url: Kadenze.Routes.temp_file_headers_path({url: url})
      });

      request.done(function(data, textStatus, xhr) {
        let headers = data.headers;
        if (headers['x-frame-options'] && (headers['x-frame-options'].toUpperCase() == 'DENY' || headers['x-frame-options'].toUpperCase() == 'SAMEORIGIN')) {
          self.showLinkPreview = false;
        } else {
          self.showLinkPreview = true;
        }
      });
    },
    submit() {
      this.$validator.validateAll();

      let linkValid = !this.errors.has('url');
      if (linkValid) {
        let data = {coursework_entry: this.coursework_entry};
        if (this.coursework.group.submitted && !this.coursework.group.self_submitted) {
          delete data.coursework_entry.id;
        }
        data.coursework_entry.coursework_field_entries_attributes = data.coursework_entry.coursework_fields[0].coursework_field_entries;
        delete data.coursework_entry.coursework_fields;
        this.$parent.submitCourseworkEntry(data, '#js-link-uploader');
      } else {
        new Kadenze.Notice.error({message: 'Please enter a valid URL.'});
      }
    },
    cancel() {
      this.$parent.coursework.is_submitting = false;
    }
  },
  mounted() {
    Kadenze.UIUtil.initExpandableTextareas();
    this.showPreview(this.coursework_entry.coursework_fields[0].coursework_field_entries[0].value);
  }
};
